import React, { useState, useRef, useEffect } from 'react';
import './AIChatButton.css';

const AIChatButton = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [messageCount, setMessageCount] = useState(0);
  const [messages, setMessages] = useState([
    { text: "Hello! I'm your AI assistant. How can I help you today?", sender: 'bot' },
    { text: "I can help you with:", sender: 'bot' },
    { text: "• Investment advice", sender: 'bot' },
    { text: "• Stock market analysis", sender: 'bot' },
    { text: "• Portfolio management", sender: 'bot' },
    { text: "• Market trends", sender: 'bot' }
  ]);
  const [inputMessage, setInputMessage] = useState('');
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  const handleSendMessage = () => {
    if (inputMessage.trim() === '') return;

    // Add user message
    setMessages(prev => [...prev, { text: inputMessage, sender: 'user' }]);
    setInputMessage('');
    setMessageCount(prev => prev + 1);

    // Simulate bot response after a short delay
    setTimeout(() => {
      if (messageCount >= 2) {
        // Show development message after 3 user messages
        setMessages(prev => [...prev, 
          { text: "⚠️ Important Notice:", sender: 'bot' },
          { text: "Our AI support system is currently under development. We're working on enhancing our capabilities to provide you with better assistance.", sender: 'bot' },
          { text: "For now, please contact our support team at mail.trillionstockresearch@gmail.com for detailed assistance.", sender: 'bot' },
          { text: "Thank you for your understanding! 🙏", sender: 'bot' }
        ]);
      } else {
        const botResponses = [
          "I understand your query. Let me help you with that.",
          "That's an interesting question. Here's what I think...",
          "Based on my analysis, I would recommend...",
          "Let me check the latest market data for you.",
          "I can provide you with detailed insights on that."
        ];
        const randomResponse = botResponses[Math.floor(Math.random() * botResponses.length)];
        setMessages(prev => [...prev, { text: randomResponse, sender: 'bot' }]);
      }
    }, 1000);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  return (
    <div className="ai-chat-container">
      <button 
        className="ai-chat-button"
        onClick={toggleChat}
      >
        <div className="ai-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="currentColor"/>
            <path d="M7 9H17V11H7V9ZM7 12H14V14H7V12Z" fill="currentColor"/>
          </svg>
        </div>
      </button>

      {isChatOpen && (
        <div className="chat-box">
          <div className="chat-box-header">
            <h3>AI Chat Support</h3>
            <button className="close-chat" onClick={toggleChat}>×</button>
          </div>
          <div className="chat-messages">
            {messages.map((message, index) => (
              <div key={index} className={`message ${message.sender}`}>
                <p>{message.text}</p>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
          <div className="chat-input">
            <input 
              type="text" 
              placeholder="Type your message..." 
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button className="send-button" onClick={handleSendMessage}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AIChatButton; 